export enum ContractorStatus {
  Active = 'active',
  Deactivated = 'deactivated',
  ExpiresSoon = 'expires_soon',
  Unknown = 'unknown',
}

export enum ContractorState {
  Active = 'active',
  Deactivated = 'deactivated',
  Recollection = 'recollection',
}

export enum ContractorDeactivationReason {
  Manual = 'manual',
  Auto = 'auto',
  GracePeriod = 'grace_period',
  ExpiredDocuments = 'expired_documents',
  FailedDocument = 'failed_document',
}

export enum SubcontractorHeaderTypes {
  ALL = 'all',
  OWN = 'own',
  SUBCONTRACTOR = 'subcontractor',
}

export enum ContractorType {
  Sub = 'sub',
  Master = 'master',
  IC = 'ic',
}

export enum RecollectionType {
  Manual = 'manual',
  Automatic = 'automatic',
}

export enum RecollectionFilterValue {
  Manual = 'manual',
  Automatic = 'automatic',
  Without = 'without',
}

export enum ExpirationIndicator {
  Valid = 'valid',
  ExpiringSoon = 'expiring_soon',
  Expired = 'expired',
}

export enum ReActivationFilterValue {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export enum CollectDataStepCreateReason {
  ManualRecollection = 'manual_recollection',
  AutoRecollection = 'auto_recollection',
  NewTemplateStep = 'new_template_step',
  TemplateUpdates = 'template_updates',
  Declined = 'declined',
}

export enum CollectDataStepCreateSource {
  Internal = 'internal',
  System = 'system',
  Api = 'api',
  Customer = 'customer',
}

export enum ContractorsTableFields {
  externalId = 'externalId',
  name = 'name',
  contractorType = 'contractorType',
  vehicleType = 'vehicleType',
  status = 'status',
  deactivationDetails = 'deactivationDetails',
  onboardingFlow = 'onboardingFlow',
  toReviewCount = 'toReviewCount',
  phone = 'phone',
  email = 'email',
  tags = 'tags',
  lastActivity = 'lastActivity',
  referral = 'referral',
  masterContractorName = 'masterContractorName',
  expiresInDays = 'expiresInDays',
  recollections = 'recollections',
  autoActivationEnabled = 'autoActivationEnabled',
  dateOnboarded = 'dateOnboarded',
  dateDeactivated = 'dateDeactivated',
}
